<template>
  <div id="login">
    <bmShouldKnow v-if="bmShouldKnowData.isNotice" :bmShouldKnowData="bmShouldKnowData"
      @clickCloseTerrace="clickCloseTerrace" @closeNotice="closeNotice"></bmShouldKnow>
    <!-- PC端登录网站 -->
    <div class="content1" :style="{
      backgroundImage: flag == 1 ? background.kuanp : background.zhaip,
    }">
      <div class="login_content">
        <!-- 头部logo -->
        <div class="content1_top">
          <div class="content1_top_outer">
            <img :src="flag == 1 ? logo.kuanp : logo.zhaip" alt="" />
            <p style="margin-top: 5px;">普通高校专升本招生管理系统</p>
            <!-- pc端飘动通知 -->
            <div class="flutterNotice" @click="noticeClick(noticeContent)">
              <marquee direction="left" scrollAmount="4">
                <p v-html="noticeContent.notice"></p>
              </marquee>
            </div>
          </div>
        </div>

        <!-- 操作区域 -->
        <div class="content1_outer">
          <div class="content1_bottom">
            <div class="content1_bottom_box">
              <div class="content1_bottom_box_name">身份证</div>
              <div class="content1_bottom_box_input">
                <el-input v-model="logindata.idcard" placeholder="请输入身份证号" clearable></el-input>
              </div>
              <div class="content1_bottom_box_name">密码</div>
              <div class="content1_bottom_box_input">
                <el-input placeholder="请输入密码" v-model="logindata.password" show-password></el-input>
              </div>
              <div class="content1_bottom_box_name">验证码</div>
              <div class="content1_bottom_box_input">
                <el-input v-model="logindata.yzm" placeholder="请输入验证码" @keyup.enter.native="Login"></el-input>
                <div class="yzm" @click="refreshCode">
                  <SIdentify :identifyCode="identifyCode" :contentWidth="contentWidth"></SIdentify>
                </div>
              </div>
              <div class="content1_bottom_info1">
                <span @click="forgetPassword">忘记密码</span>
                <span @click="register">注册</span>
              </div>
              <div class="content1_bottom_btn" @click="Login">登录</div>
            </div>
          </div>
        </div>
      </div>
      <div class="technicalSupport">{{ this.$technicalSupport }}</div>
    </div>
  </div>
</template>

<script>
import SIdentify from "./identify.vue";

import bmShouldKnow from "./bmShouldKnow.vue";
export default {
  //动态验证码
  components: {
    // Verify,
    //验证码
    SIdentify: SIdentify,
    bmShouldKnow,
  },
  data() {
    return {
      background: {
        kuanp: "url(" + require("../assets/img/login_bg2.jpg") + ")",
        zhaip: "url(" + require("../assets/img/bj.png") + ")",
      },
      logo:{
        kuanp:require("../assets/img/logo2.png"),
        zhaip:require("../assets/img/logo2_1.png"),
      },
      //pdf弹窗
      bmShouldKnowData: {
        isNotice: false, //是否需要提示
        name: "", //标题名称
        path: "", //须知内容(pdf路径)
        entrance: "", //其他平台入口地址
        scoreUpload: false,
      },
      flag: 0, //判断屏幕是横屏还是竖屏
      showscreen: false,
      noticeContent: "", //飘动通知
      xtName: "对口升学报名资料审核系统",
      // agree: "",  报名须知

      logindata: {
        idcard: "",
        password: "",
        yzm: "",
      },
      contentWidth_phone: 100,
      contentHeight_phone: 48,
      identifyCode: "", //验证码
      contentWidth: 100,
      identifyCodes: "1234567890",
    };
  },
  methods: {
    noticeClick(noticeContent) {
      if (noticeContent.noticeFile.path.length > 5) {
        this.bmShouldKnowData.path = noticeContent.noticeFile.path;
        let name = noticeContent.noticeFile.name.replace(".pdf", "");
        this.bmShouldKnowData.name = name;
        this.bmShouldKnowData.isNotice = true;
      }
    },
    clickCloseTerrace(value) {
      this.clickCloseTerraceflag = value;
      this.bmShouldKnowData.isNotice = value;
      window.open(this.bmShouldKnowData.path);
    },
    closeNotice(flag) {
      this.bmShouldKnowData.isNotice = flag;
    },
    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;
      } else {
        this.flag = 2;
      }
      this.makeCode(this.identifyCodes, 4);
    },
    //验证码abcdefghijklnmopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    //换验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    // 非空校验
    notnullverification() {
      if (this.logindata.idcard == "" || this.logindata.password == "") {
        return false;
      }
      return true;
    },
    //错误时清空输入框数据
    cleandata() {
      // this.logindata.idcard = "";
      // this.logindata.password = "";
      this.logindata.yzm = "";
      this.refreshCode();
    },
    //登录
    Login() {
      // if (this.agree == "") {
      //   this.$alert("请先勾选 《报名须知》", "登录须知", {
      //     confirmButtonText: "确定",
      //     callback: (action) => {},
      //   });
      //   return;
      // }
      if (this.notnullverification()) {
        if (this.logindata.yzm == this.identifyCode) {
          let logindata = {
            idCard: this.logindata.idcard,
            password: this.logindata.password,
          };
          this.$request("post", "/student/login", logindata, (data) => {
            sessionStorage.setItem("ID", data.id); //学生ID
            sessionStorage.setItem("enrollId", data.enrollId); //资料ID
            //将注册时填写的信息存起来
            sessionStorage.setItem("registrationidCard", data.idCard); //资料ID
            sessionStorage.setItem("registrationphone", data.phone); //资料ID
            sessionStorage.setItem("registrationprofession", data.profession); //资料ID
            sessionStorage.setItem("registrationschool", data.school); //资料ID
            sessionStorage.setItem("name", data.name); //登录人姓名
            //将注册时填写的信息存起来

            this.$message({
              message: "登录成功!",
              type: "success",
            });
            setTimeout(() => {
              this.$router.push("/dataRequest"); //跳转到资料申请页面
            }, 500);
          });
        } else {
          this.cleandata();
          this.$message({
            message: "验证码错误,请重新登录!",
            type: "error",
          });
        }
      } else {
        this.refreshCode();
        this.$message({
          message: "身份证号或密码不能为空!",
          type: "error",
        });
      }
    },

    //忘记密码
    forgetPassword() {
      this.$router.push("/forgetPassword");
    },
    //注册
    register() {
      this.$router.push("/register");
    },
    //查看公告
    getNotice() {
      this.$request("post", "/getNotice", null, (data) => {
        this.noticeContent = data;
      });
    },
  },
  mounted() {
    this.start(); //判断设备
    this.getNotice(); //飘动通知
  },
};
</script>

<style lang="less" scoped>
#login {
  width: 100%;
  height: 100%;

  /* PC端 */
  .content1 {
    width: 100%;
    height: 100%;
    background: url("../assets/img/login_bg1.jpg") no-repeat;
    background-size: 100% auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .login_content {
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      .content1_top {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        box-sizing: border-box;
        margin-right: 10px;
        margin-top: 10vh;

        .content1_top_outer {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          >img {
            width: 350px;
            height: 70px;
            margin-right: 20px;
          }

          >p {
            font-size: 25px;
            font-weight: 800;
            letter-spacing: 5px;
            margin-left: 20px;
            color: #ff0000;
          }

          .flutterNotice {
            display: flex;
            align-items: center;
            width: 70%;
            max-width: 700px;
            min-width: 280px;
            height: 30px;
            background: rgba(255, 255, 255, 0.635);
            border: 1px solid #054e8e;
            border-radius: 5px;
            overflow: hidden;
            cursor: pointer;

            &:hover {
              color: #025bc0;
            }

            >marquee {
              font-size: 15px;

              >p {
                text-decoration: none;
              }
            }
          }
        }
      }

      .content1_outer {
        width: 100%;
        // height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 3%;

        .content1_bottom {
          width: 50%;
          max-width: 480px;
          min-width: 280px;
          height: 380px;
          box-sizing: border-box;
          opacity: 0.95;
          border-radius: 10px;
          background: rgba(255, 255, 255, 1);
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          // justify-content: space-between;
          // align-items: flex-start;
          .content1_bottom_box {
            // width: 21.25rem;
            // height: 25rem;
            width: 90%;
            height: 90%;
            display: flex;
            flex-direction: column;
            justify-content: center;

            align-items: center;

            .content1_bottom_box_name {
              width: 100%;
              font-size: 15px;
              font-weight: 400;
              letter-spacing: 2px;
              margin-bottom: 0.625rem;
              font-weight: 700;
              display: flex;
            }

            .content1_bottom_box_input {
              width: 100%;
              height: 2.8125rem;
              margin-bottom: 0.625rem;
              display: flex;
              align-items: center;
              position: relative;

              .yzm {
                height: 100%;
                position: absolute;
                right: 0;
                top: 0;
                border-radius: 12px;
                overflow: hidden;
              }
            }

            .content1_bottom_info1 {
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;

              >span {
                font-size: 14px;
                font-weight: 700;

                &:hover {
                  cursor: pointer;
                }
              }
            }

            .content1_bottom_btn {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 2.8125rem;
              border-radius: 7px;
              background: rgba(0, 79, 146, 1);
              font-size: 16px;
              font-weight: 400;
              letter-spacing: 5px;
              color: #fff;

              &:hover {
                cursor: pointer;
              }
            }

            .content1_bottom_info2 {
              width: 100%;
              height: 12px;
              display: flex;
              justify-content: center;

              .infoblue {
                line-height: 17px;
                font-size: 9px;
                color: rgba(26, 133, 255, 1);

                &:hover {
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }

    .technicalSupport {
      width: 100%;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #fff;
    }
  }




}
</style>
